// This module must be imported before any module that transitively imports
// src/api/crud.js. crud.js captures window.fetch at module load time to guard
// against third-party script (GTM/pixel) corruption. LogRocket also patches
// window.fetch at init time — so we must init before crud.js loads.
import LogRocket from 'logrocket';
import { isProd, isTrashieApp } from './config/config';
import { TRASHIE_LOGROCKET_APP_ID } from './components/trashie/config/config';
import { sanitizeNetworkBody } from './components/trashie/utils/analytics';

if (isTrashieApp()) {
  const sanitizeBody = (body) => {
    try {
      return JSON.stringify(sanitizeNetworkBody(JSON.parse(body)));
    } catch (e) {
      return body;
    }
  };

  LogRocket.init(
    isProd() ? TRASHIE_LOGROCKET_APP_ID.PRODUCTION : TRASHIE_LOGROCKET_APP_ID.STAGING,
    {
      release: process.env.REACT_APP_VERSION,
      network: {
        requestSanitizer: (request) => {
          if (request.headers) {
            request.headers.Authorization = undefined;
            request.headers.authorization = undefined;
          }
          if (request.body) {
            request.body = sanitizeBody(request.body);
          }
          return request;
        },
        responseSanitizer: (response) => {
          if (response.body) {
            response.body = sanitizeBody(response.body);
          }
          return response;
        },
      },
    },
  );
}
